import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { MessageCircle } from 'lucide-react'; // if using lucide-react
import './JourneyAdmin.css';
import MontagePanel from './MontagePanel';
const MessageInput = ({ message, setMessage }) => {
  const iconToolbox = [
    '😀', '😁', '😎', '🥳', '👏', '🙌', '👍', '💪', '✅', '🔥', '🎯', '🌟', '✨', '🚀',
    '💡', '🎉', '🎬', '🎵', '📷', '📹', '🧠', '📝', '📌', '📣', '💬', '❤️', '🤩'
  ];

  const insertIcon = (icon) => {
    setMessage((prev) => prev + ' ' + icon);
  };

  return (
    <div className="w-100">


      <textarea
        rows={2}
        className="w-100"
        style={{
          width: '100%',
          fontSize: '1rem',
          padding: '1rem',
          border: '1px solid #ccc',
          borderRadius: '8px',
          resize: 'vertical',
          background: '#f9f9f9',
        }}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Ajoutez un message pour les contributeurs (ex. bravo, prochaine étape, etc.)"
      />
      <div className="flex flex-wrap gap-3 mb-3">
        {iconToolbox.map((icon, idx) => (
          <span
            key={idx}
            onClick={() => insertIcon(icon)}
            className="text-2xl cursor-pointer hover:scale-110 transition-transform"
            style={{ border: 'none', background: 'transparent' }}
          >
            {icon}
          </span>
        ))}
      </div>
    </div>
  );
};
function JourneyAdmin() {

  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('scenarios');
  const [scenario, setScenario] = useState([]);
  const [scenarioInput, setScenarioInput] = useState('');
  const [media, setMedia] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [exportConfig, setExportConfig] = useState({ format: 'mp4', quality: 'HD', channel: 'YouTube' });
  const [aiComments, setAiComments] = useState([]);
  const scrollContainerRef = useRef(null);
  const [selectedMediaIds, setSelectedMediaIds] = useState([]);
  const [message, setMessage] = useState('');
  const [isGenerating, setIsGenerating] = useState(false);
  const [aiResultUrl, setAiResultUrl] = useState(null);
  const [youtubeStats, setYoutubeStats] = useState(null);
  const [aiMontagePlan, setAiMontagePlan] = useState('');
  const [finalVideoUrl, setFinalVideoUrl] = useState('');
  const [generating, setGenerating] = useState(false);
  const [montageMode, setMontageMode] = useState("Assisté par l'IA");
  const [theme, setTheme] = useState('🎬 Documentaire');
  const [voiceOverFile, setVoiceOverFile] = useState(null);
  const [musicFile, setMusicFile] = useState(null);
  const [voiceOverFileName, setVoiceOverFileName] = useState(null);
  const [isGeneratingVoice, setIsGeneratingVoice] = useState(false);
  const audioRef = useRef(null);
  const [voiceGender, setVoiceGender] = useState('FEMALE');
  const [voiceLang, setVoiceLang] = useState('fr-FR');
  const [audioMixOption, setAudioMixOption] = useState("voice+music"); // or "voice"
  const [musicVolume, setMusicVolume] = useState(20); // par défaut à 20%
  const [montageType, setMontageType] = useState('concat');
  const [params, setParams] = useState({});
  const [files, setFiles] = useState([]);
  const [previewUrl, setPreviewUrl] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [shareTitle, setShareTitle] = useState('');
  const [shareDescription, setShareDescription] = useState('');
  const [isPublishing, setIsPublishing] = useState(false);
  const [youtubeVideoId, setYoutubeVideoId] = useState(null);
  const videoRef = useRef(null);

  const handleParamChange = (e) => {
    setParams({ ...params, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleGenerate = async () => {
    setIsProcessing(true);
    const formData = new FormData();
    formData.append('type', montageType);
    files.forEach(file => formData.append('files', file));
    Object.entries(params).forEach(([key, value]) => formData.append(key, value));

    try {
      const res = await axios.post('/api/montage', formData, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'video/mp4' });
      setPreviewUrl(URL.createObjectURL(blob));
    } catch (error) {
      console.error(error);
    }
    setIsProcessing(false);
  };
  useEffect(() => {
    fetch(`/projects/${id}/scenarios`).then(res => res.json()).then(setScenario);

    fetch(`/projects/${id}/media`)
      .then(res => res.json())
      .then(data => {
        console.log("🔁 useEffect exécuté avec ID =", id);
        console.log("🎞 Médias récupérés :", data);
        setMedia(data);
      });
    fetch(`/projects/${id}/media-comments`)
      .then(res => res.json())
      .then(data => setAiComments(data));
  }, [id]);



  {
    aiResultUrl && (
      <div className="alert alert-success mt-3">
        🎬 Montage IA prêt : <a href={aiResultUrl} target="_blank" rel="noreferrer">Voir la vidéo</a>
      </div>
    )
  }
 


  
  const handleCloseProject = async () => {
    try {
      const response = await fetch(`/projects/${id}/close`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: message // message de clôture si besoin
        })
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la clôture du projet");
      }

      window.location.href = '/dashboard'; // ou utilise navigate() si tu as react-router v6+
    } catch (error) {
      console.error("❌ Erreur :", error);
      alert("Une erreur est survenue lors de la clôture.");
    }
  };
  useEffect(() => {
    if (youtubeVideoId) {
      fetch(`/youtube/stats/${youtubeVideoId}`)
        .then(res => res.json())
        .then(setYoutubeStats)
        .catch(err => console.error("Erreur chargement stats :", err));
    }
  }, [youtubeVideoId]);
  useEffect(() => {
    if (voiceOverFile && !isGeneratingVoice && audioRef.current) {
      audioRef.current.load();
      audioRef.current.play().catch((err) => {
        console.warn("⏯️ Auto-play bloqué par le navigateur :", err.message);
      });
    }
  }, [voiceOverFile, isGeneratingVoice]);
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(media);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    setMedia(reordered);
  };
  // Pour stocker les commentaires
  const handleMediaCommentChange = (index, text) => {
    const updated = [...media];
    updated[index].comment = text;
    setMedia(updated);
  };
  const handleValidateScenario = async () => {
    setActiveTab('media');
  }
  const handleGenerateTTS = async () => {
    alert("🔊 TTS IA à intégrer (appel backend Google TTS)");
  };
  // Simuler action IA ou manuelle
  const handleManualMontage = () => {
    alert("Téléchargez vos fichiers et effectuez le montage dans un logiciel externe.");
  };

  const handleMontageIA = async () => {
    alert("Montage IA en cours… (à connecter à FFmpeg / Agent AI)");
    // Tu pourras ici appeler le backend IA
  };

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    const cardWidth = 240;
    const index = Math.round(container.scrollLeft / cardWidth);
    setCurrentIndex(index);
  };

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const cardWidth = 240;
    container.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
  };


  const toggleSelectMedia = (id) => {
    setSelectedMediaIds(prev =>
      prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]
    );
  };


  const generateFinalVideo = async () => {
    setGenerating(true);
    setFinalVideoUrl('');

    try {
      const res = await fetch(`/projects/${id}/generate-final-video`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          theme,
          voice_over_type: voiceOverFile ? "file" : "ia",
          media_order: media
            .filter((m) => selectedMediaIds.includes(m.id))
            .map((m) => m.id),
          audio_mix_option: audioMixOption,
          music_volume: musicVolume / 100  // backend attend un ratio (0.2 = 20%)
        })
      });

      const data = await res.json();
      if (data.videoUrl) {
        setFinalVideoUrl(data.videoUrl);
      } else {
        alert("Erreur lors de la génération de la vidéo.");
      }
    } catch (error) {
      console.error("Erreur vidéo :", error);
      alert("Erreur lors de la requête.");
    } finally {
      setGenerating(false);
    }
  };



  const handleValidateSelection = async () => {
    if (selectedMediaIds.length === 0) {
      alert("⚠️ Veuillez sélectionner au moins un média.");
      return;
    }

    try {
      const response = await fetch(`/projects/${id}/media/selection`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          selectedMediaIds,
          message: message,
        }),
      });

      if (!response.ok) {
        throw new Error('Erreur lors de la validation');
      }

      setActiveTab('montage');
    } catch (error) {
      console.error("❌ Erreur lors de la validation :", error);
      alert("Erreur lors de la soumission. Vérifiez le backend.");
    }
  };
  const handleDownloadMontageZip = async () => {
    try {
      const response = await fetch(`/projects/${id}/export-montage`, {
        method: 'GET',
      });

      if (!response.ok) throw new Error('Erreur lors du téléchargement');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `montage_project_${id}.zip`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('❌ Erreur export montage :', error);
      alert('Erreur lors de la génération du montage ZIP.');
    }
  };



  const handleMontageSave = async () => {
    try {
      const form = document.querySelector("#montage-form");
      const formData = new FormData();
      const theme = form?.querySelector("select[name='theme']")?.value;
      const musicInput = form?.querySelector("input[name='music']");
  
      const uploadedMusicFile = musicInput?.files?.[0] || null;
  
      formData.append("project_id", id);
      formData.append("montage_type", montageMode);
      formData.append("theme", theme || "");
  
      // 🛠 Correct voice handling:
      if (voiceOverFile) {
        // If manual voice file is uploaded (via React state)
        formData.append("voice_over", voiceOverFile);
        formData.append("voice_over_type", "file");
      } else if (voiceOverFileName) {
        // If AI-generated voice
        formData.append("voice_file", voiceOverFileName);
        formData.append("voice_over_type", "ia");
      } else {
        // No voice over
        formData.append("voice_over_type", "none");
      }
  
      // 🛠 Correct music handling:
      if (uploadedMusicFile) {
        formData.append("music", uploadedMusicFile);
        formData.append("musicFile", "file");
      } else if (musicFile) {
        formData.append("music", musicFile);
        formData.append("musicFile", "file");
      } else {
        formData.append("musicFile", "");
      }
  
      // 🛠 Media order
      const selectedOrderedMediaIds = media
        .filter((m) => selectedMediaIds.includes(m.id))
        .map((m) => m.id);
  
      formData.append("media_order", JSON.stringify(selectedOrderedMediaIds));
  
      const response = await fetch(`/projects/${id}/save-montage`, {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) throw new Error("Erreur lors de la sauvegarde");
  
      const data = await response.json();
      console.log("✅ Montage sauvegardé :", data);
      setActiveTab("export");
    } catch (error) {
      console.error("❌ Erreur lors de la sauvegarde du montage :", error);
      alert("Erreur lors de la sauvegarde du montage.");
    }
  };
  


  
  const handleGenerateVoice = async () => {
    if (!scenario || !scenario.description) {
      alert("❌ Le scénario n’est pas encore chargé.");
      return;
    }
  
    const descriptionText = scenario.description;
  
    setIsGeneratingVoice(true);
    try {
      const res = await fetch(`/projects/${id}/generate-voice`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          text: descriptionText,
          gender: voiceGender,
          languageCode: voiceLang
        })
      });
  
      const data = await res.json();
      if (data.voiceFile) {
        setVoiceOverFileName(data.voiceFile); // ✅ Save the filename
        setVoiceOverFile(null);               // ✅ Clear manual upload
      } else {
        alert("❌ Erreur lors de la génération");
      }
    } catch (err) {
      alert("Erreur lors de l’appel IA");
      console.error(err);
    } finally {
      setIsGeneratingVoice(false);
    }
  };
  


  const addScenario = async () => {
    if (!scenarioInput) return;

    try {
      await fetch(`/projects/${id}/scenarios`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content: scenarioInput })
      });

      setScenarioInput('');

      // Optionnel : rafraîchir la liste si besoin
      const updated = await fetch(`/projects/${id}/scenarios`).then(res => res.json());
      setScenarios(updated);

      // ⏩ Aller à l’étape suivante
      setActiveTab('media');
    } catch (error) {
      console.error("Erreur lors de l'ajout du scénario :", error);
      alert("❌ Une erreur est survenue lors de l’ajout du scénario.");
    }
  };

  const handleExport = async () => {
    await fetch(`/projects/${id}/export`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(exportConfig)
    });
    alert('✅ Export enregistré avec succès !');
  };
  const handleAiMontage = async () => {
    setIsGenerating(true);
    setAiResultUrl(null);

    try {
      const response = await fetch(`/projects/${id}/generate-ai-montage`, {
        method: 'POST',
      });

      if (!response.ok) throw new Error('Erreur génération IA');

      const result = await response.json();
      setAiResultUrl(result.videoUrl);
      setAiMontagePlan(result.plan); // plan textuel IA
      {
        aiMontagePlan && (
          <div className="alert alert-light mt-4 p-3 border rounded shadow-sm">
            <h5>📝 Plan de montage IA</h5>
            <pre style={{ whiteSpace: 'pre-wrap' }}>{aiMontagePlan}</pre>
          </div>
        )
      }


      alert("✅ Montage IA lancé avec succès !");
    } catch (err) {
      console.error("Erreur IA montage :", err);
      alert("❌ Erreur lors de la génération du montage via IA.");
    } finally {
      setIsGenerating(false);
    }
  };

  const getProgress = () => {
    switch (activeTab) {
      case 'scenarios': return 20;
      case 'media': return 40;
      case 'montage': return 70;
      case 'export': return 100;
      default: return 0;
    }
  };

  return (
    <div className="admin-container" style={{ paddingTop: '70px' }}>
      
      <div className="admin-sidebar">
        <button className={activeTab === 'scenarios' ? 'active' : ''} onClick={() => setActiveTab('scenarios')}>📚 Scénarios</button>
        <button className={activeTab === 'media' ? 'active' : ''} onClick={() => setActiveTab('media')}>🎞️ Médias</button>
        <button className={activeTab === 'montage' ? 'active' : ''} onClick={() => setActiveTab('montage')}>🛠 Montage</button>
        <button className={activeTab === 'export' ? 'active' : ''} onClick={() => setActiveTab('export')}>📤 Export</button>
     </div>

      <div className="admin-content">
        <br></br><br></br>
        <div className="progress mb-3" style={{ height: '8px' }}>
          <div
            className="progress-bar bg-info"
            role="progressbar"
            style={{ width: `${getProgress()}%` }}
            aria-valuenow={getProgress()}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>

        <div className="text-center text-muted mb-4">
          Étape actuelle : <strong>
            {activeTab === 'scenarios' ? '📚 Scénarios' :
              activeTab === 'media' ? '🎞 Médias' :
                activeTab === 'montage' ? '🛠 Montage' :
                  '📤 Export'}
          </strong>
        </div>

        {activeTab === 'scenarios' && scenario && (
          <div className="bg-white p-4 rounded-4 shadow-sm border">
            <h3 className="fw-bold text-primary mb-3 d-flex align-items-center gap-2">
              🎬 {scenario.title}
            </h3>
            <p className="text-muted fs-5 mb-4">{scenario.description}</p>

            <div className="timeline">
              {JSON.parse(scenario.steps || '[]').map((step, index) => (
                <div
                  key={index}
                  className="timeline-item position-relative ps-4 mb-5 fade-in"
                  style={{ transition: 'all 0.4s ease-in-out' }}
                >
                  <div className="timeline-dot bg-primary position-absolute top-0 start-0 translate-middle rounded-circle" style={{ width: 16, height: 16 }}></div>

                  <div className="bg-light-subtle p-4 rounded-3 shadow-sm border-start border-4 border-primary">
                    <h5 className="mb-2 text-primary d-flex align-items-center gap-2">
                      📍 {step.location}
                    </h5>
                    <p className="text-dark mb-2 fst-italic">{step.description}</p>

                    {step.reference && (
                      <p className="text-muted small mb-2">
                        🔗 <a href={step.reference} target="_blank" rel="noreferrer">Voir la ressource</a>
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-end mt-3">
              <button className="btn btn-success" onClick={handleValidateScenario}>
                ✅ Scénario validé ! Passons au choix des médias➡️🎞️
              </button>

            </div>
          </div>
        )}


        {activeTab === 'media' && (

          <>
            <h4 className="mb-4">🎬 Étape 2 : Sélection des médias pour le produit final</h4>
            <div className="form-check mb-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="selectAllMedia"
                checked={selectedMediaIds.length === media.length && media.length > 0}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedMediaIds(media.map((item) => item.id));
                  } else {
                    setSelectedMediaIds([]);
                  }
                }}
              />
              <label className="form-check-label" htmlFor="selectAllMedia">
                Tout sélectionner
              </label>
            </div>
            {media.length > 0 ? (

              <div className="media-grid">
                {media.map((item) => {
                  const isVideo = item.file_path.match(/\.(mp4|webm|ogg)$/i);
                  const mediaUrl = `https://www.weavevo.com/uploads/${item.file_path}`;
                  const isSelected = selectedMediaIds.includes(item.id);

                  return (

                    <div
                      key={item.id}
                      className={`media-card position-relative shadow-sm rounded-4 ${isSelected ? 'border border-success border-3' : 'border border-secondary'}`}
                      onClick={() => toggleSelectMedia(item.id)}
                    >
                      {isVideo ? (
                        <video
                        src={mediaUrl}
                        className="w-100 h-100 object-fit-cover"
                        playsInline
                        preload="metadata"
                        autoPlay
                        controls
                      />
                      ) : (
                        <img
                          src={mediaUrl}
                          alt={item.title}
                          className="w-100 h-100 object-fit-cover"
                        />
                      )}

                      <div className="position-absolute top-0 end-0 m-2">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          onChange={() => toggleSelectMedia(item.id)}
                          className="form-check-input"
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div className="position-absolute bottom-0 w-100 text-white text-center bg-black bg-opacity-50 py-1 small">
                        {item.title}
                      </div>

                    </div>

                  );
                })}
              </div>
            ) : (
              <div className="alert alert-info text-center rounded-4 p-4 shadow-sm">
                🎉 <strong>Aucun média disponible</strong><br />
                Ajoute un média pour commencer la sélection 🚀
              </div>
            )}

            {/* Champ message admin */}


            <div className="mt-8">
              <label className="form-label flex items-center gap-2 text-gray-700 font-semibold mb-2">
                <br></br>
                <h4 className="mb-4">
                  💬 Message à l'équipe :
                </h4>
              </label>

              <MessageInput message={message} setMessage={setMessage} />

            </div>


            <div className="text-end mt-3">
              <button className="btn btn-success" onClick={handleValidateSelection}>
                🎬 Finaliser la sélection et lancer le montage🚀
              </button>

            </div>
          </>
        )}


        {activeTab === 'montage' && (
          <div className="pt-4 px-2">
            <h3 className="mb-4 text-primary">🎬 Montage du documentaire</h3>

            <div className="row">
              {/* Timeline centrale */}
              <div className="col-md-8">
                <div className="mb-4">
                  <label className="form-label">🎚️Montage Assisté par IA</label>
                  <select
                    className="form-select w-auto"
                    value={montageMode}
                    onChange={(e) => setMontageMode(e.target.value)}
                  >
                    <option value="ia">🤖 Assisté par IA</option>
                    <option value="manual">🎛️ Manuel</option>

                  </select>
                </div>

                <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="timeline" direction="horizontal">
                    {(provided) => (
                      <div
                        className="d-flex overflow-auto gap-3 flex-nowrap pb-3"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {media
                          .filter((m) => selectedMediaIds.includes(m.id))
                          .map((medias, index) => (
                            <Draggable
                              key={medias.id}
                              draggableId={medias.id.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  className="timeline-item border rounded p-2 bg-white shadow-sm"
                                  style={{ width: 180, minHeight: 240 }}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <div className="text-center small text-muted mb-2">
                                    🎬 Élément {index + 1}
                                  </div>

                                  <div
                                    style={{
                                      height: 150,
                                      overflow: 'hidden',
                                      borderRadius: 8,
                                    }}
                                  >
                                    {/\.(jpg|jpeg|png)$/i.test(medias.file_path) ? (
                                      <img
                                        src={`https://www.weavevo.com/uploads/${medias.file_path}`}
                                        className="img-fluid rounded"
                                        alt={medias.title}
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                    ) : (
                                      <video
                                        src={`https://www.weavevo.com/uploads/${medias.file_path}`}
                                        className="w-100 rounded"
                                        controls
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                    )}
                                  </div>

                                  <textarea
                                    className="form-control form-control-sm mt-2"
                                    placeholder="Commentaire IA ou texte…"
                                    value={medias.comment || ''}
                                    onChange={(e) =>
                                      handleMediaCommentChange(index, e.target.value)
                                    }
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </div>

              {/* Panneau d’options */}
              <div className="col-md-4">
                <div className="bg-white p-3 rounded shadow-sm border">
                  <h5 className="text-secondary mb-3">⚙️ Options</h5>

                  <div className="accordion" id="optionsAccordion">

                    {/* 🎤 VOIX-OFF */}
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingVoice">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseVoice" aria-expanded="true" aria-controls="collapseVoice">
                          🎤 Voix-off IA
                        </button>
                      </h2>
                      <div id="collapseVoice" className="accordion-collapse collapse show" aria-labelledby="headingVoice" data-bs-parent="#optionsAccordion">
                        <div className="accordion-body">
                          <label className="form-label">👤 Type de voix</label>
                          <select className="form-select form-select-sm mb-2" value={voiceGender} onChange={(e) => setVoiceGender(e.target.value)}>
                            <option value="FEMALE">👩 Féminine</option>
                            <option value="MALE">👨 Masculine</option>
                          </select>

                          <label className="form-label">🌐 Langue</label>
                          <select className="form-select form-select-sm mb-3" value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)}>
                            <option value="fr-FR">🇫🇷 Français</option>
                            <option value="en-US">🇺🇸 Anglais</option>
                            <option value="es-ES">🇪🇸 Espagnol</option>
                            <option value="de-DE">🇩🇪 Allemand</option>
                            <option value="it-IT">🇮🇹 Italien</option>
                            <option value="ar-XA">🇸🇦 Arabe</option>
                          </select>

                          <div className="d-grid gap-2 mb-3">
                            <button className="btn btn-outline-secondary btn-sm" onClick={handleGenerateVoice}>
                              {isGeneratingVoice ? "⏳ En cours..." : "🎤 Générer la voix-off IA"}
                            </button>
                          </div>

                          {voiceOverFile && !isGeneratingVoice && (
                            <div className="mb-3">
                              <p className="text-muted small mb-1">🔊 Aperçu :</p>
                              <audio ref={audioRef} controls>
                                <source src={URL.createObjectURL(voiceOverFile)} type="audio/mp3" />
                              </audio>
                            </div>
                          )}

                          <input type="file" accept="audio/*" className="form-control form-control-sm" onChange={(e) => setVoiceOverFile(e.target.files?.[0] || null)} name="voice_over" />
                        </div>
                      </div>
                    </div>

                    {/* 🎵 MUSIQUE */}
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingMusic">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMusic" aria-expanded="false" aria-controls="collapseMusic">
                          🎶 Musique
                        </button>
                      </h2>
                      <div id="collapseMusic" className="accordion-collapse collapse" aria-labelledby="headingMusic" data-bs-parent="#optionsAccordion">
                        <div className="accordion-body">
                          <input type="file" accept="audio/*" className="form-control form-control-sm mb-2" onChange={(e) => setMusicFile(e.target.files?.[0] || null)} name="music" />
                {/* 🎵 MUSIQUE */}
                          <label className="form-label">🔊 Mix audio</label>
                          <select className="form-select form-select-sm mb-2" value={audioMixOption} onChange={(e) => setAudioMixOption(e.target.value)}>
                            <option value="voice+music">🎧 Voix + Musique</option>
                            <option value="voice">🎙️ Voix seule</option>
                          </select>
                          {audioMixOption === 'voice+music' && (
                            <>
                              <label className="form-label">🎚️ Volume musique : {musicVolume}%</label>
                              <input
                                type="range"
                                min="0"
                                max="100"
                                step="1"
                                value={musicVolume}
                                onChange={(e) => setMusicVolume(parseInt(e.target.value))}
                                className="form-range"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* 🎨 THÈME */}
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTheme">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTheme" aria-expanded="false" aria-controls="collapseTheme">
                          🖼️ Thème
                        </button>
                      </h2>
                      <div id="collapseTheme" className="accordion-collapse collapse" aria-labelledby="headingTheme" data-bs-parent="#optionsAccordion">
                        <div className="accordion-body">
                          <select className="form-select form-select-sm" name="theme" value={theme} onChange={(e) => setTheme(e.target.value)}>
                            <option value="🎬 Documentaire">🎬 Documentaire</option>
                            <option value="🌍 Voyage">🌍 Voyage</option>
                            <option value="✨ Dynamique">✨ Dynamique</option>
                            <option value="📜 Patrimoine">📜 Patrimoine</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="accordion" id="montageAccordion">

                      {/* 📦 TYPE DE MONTAGE */}
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingType">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseType" aria-expanded="true" aria-controls="collapseType">
                            📦 Type de montage
                          </button>
                        </h2>
                        <div id="collapseType" className="accordion-collapse collapse show" data-bs-parent="#montageAccordion">
                          <div className="accordion-body">
                            <select className="form-select form-select-sm" value={montageType} onChange={(e) => setMontageType(e.target.value)}>
                              <option value="concat">📺 Concaténation</option>
                              <option value="trim">✂️ Découpe</option>
                              <option value="drawtext">📝 Texte</option>
                              <option value="overlay">🖼️ Overlay</option>
                              <option value="xfade">🎞️ Transition (fondu)</option>
                              <option value="speed">⏩ Vitesse</option>
                              <option value="slideshow">🖼️ Diaporama</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* ⚙️ OPTIONS SPÉCIFIQUES */}
                     
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingVideoParams">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseVideoParams" aria-expanded="false" aria-controls="collapseVideoParams">
                            🎛️ Paramètres vidéo
                          </button>
                        </h2>
                        <div id="collapseVideoParams" className="accordion-collapse collapse" data-bs-parent="#montageAccordion">
                          <div className="accordion-body">
                            <label className="form-label">🖥️ Résolution de sortie</label>
                            <select className="form-select form-select-sm mb-3" name="resolution" onChange={handleParamChange}>
                              <option value="">Automatique</option>
                              <option value="1920x1080">🎥 Full HD (1920x1080)</option>
                              <option value="1280x720">📺 HD (1280x720)</option>
                              <option value="640x480">📼 SD (640x480)</option>
                            </select>

                            <label className="form-label">🧭 Orientation</label>
                            <select className="form-select form-select-sm mb-3" name="orientation" onChange={handleParamChange}>
                              <option value="">Automatique</option>
                              <option value="landscape">📽️ Paysage</option>
                              <option value="portrait">📱 Portrait</option>
                              <option value="square">🔲 Carré</option>
                            </select>

                            <label className="form-label">🖼️ Format de sortie</label>
                            <select className="form-select form-select-sm mb-3" name="format" onChange={handleParamChange}>
                              <option value="mp4">🎬 MP4</option>
                              <option value="webm">🌐 WebM</option>
                              <option value="mov">🍎 MOV</option>
                            </select>

                            <label className="form-label">⏱️ Durée maximale</label>
                            <input type="text" className="form-control form-control-sm mb-3" name="max_duration" placeholder="ex: 00:01:00 pour 1 min" onChange={handleParamChange} />

                            <label className="form-label">🎨 Filtre visuel</label>
                            <select className="form-select form-select-sm mb-3" name="filter" onChange={handleParamChange}>
                              <option value="">Aucun</option>
                              <option value="grayscale">🖤 Noir & Blanc</option>
                              <option value="sepia">🟤 Sépia</option>
                              <option value="negate">🎭 Inversé</option>
                              <option value="vintage">📼 Vintage</option>
                            </select>

                            <div className="form-check form-switch">
                              <input className="form-check-input" type="checkbox" id="loopSwitch" name="loop" onChange={handleParamChange} />
                              <label className="form-check-label" htmlFor="loopSwitch">🔁 Boucler la vidéo</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* 📁 FICHIERS */}
                     
                     

                      {/* 🔍 PRÉVISUALISATION */}
                      {previewUrl && (
                        <div className="accordion-item mt-3">
                          <div className="accordion-body">
                            <p className="text-muted small mb-1">🔍 Aperçu du montage :</p>
                            <video ref={videoRef} controls src={previewUrl} className="w-100 rounded shadow-sm" />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Panneau de montage */}

            </div>

            {/* Actions bas de page */}
            <div className="d-flex justify-content-between mt-5 flex-wrap gap-3">
              {montageMode === 'manual' && (
                <div className="d-flex align-items-end gap-3 flex-wrap">
                  {/* Bouton de téléchargement ZIP */}
                  <div>
                    <button className="btn btn-primary">
                      🎞️ Télécharger les médias + scénario
                    </button>
                  </div>

                  {/* Upload vidéo montée */}
                  <div>
                    <label className="form-label mb-1">📤 Upload vidéo montée</label>
                    <input
                      type="file"
                      accept="video/*"
                      className="form-control form-control-sm"
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (!file) return;

                        const formData = new FormData();
                        formData.append("final_video", file);

                        fetch(`/projects/${id}/upload-final-video`, {
                          method: "POST",
                          body: formData,
                        })
                          .then((res) => res.json())
                          .then((data) => {
                            alert("✅ Vidéo manuelle uploadée !");
                            console.log("Réponse serveur :", data);
                          })
                          .catch((err) => {
                            alert("❌ Erreur lors de l’upload.");
                            console.error(err);
                          });
                      }}
                    />
                  </div>
                </div>
              )}

              {/* <button className="btn btn-outline-secondary" onClick={handleMontageSave}>
                💾 Sauvegarder ce montage
              </button>
              
              {montageMode === 'manual' ? (
                <button className="btn btn-primary" onClick={handleDownloadMontageZip}>
                  🎞️ Sauvegarder ce montage
                </button>
              ) : (
                <button className="btn btn-success" onClick={handleMontageSave}>
                  🤖 Sauvegarder ce montage
                </button>
              )*/
                <button className="btn btn-success" onClick={handleMontageSave}>
                  🤖 Sauvegarder ce montage
                </button>
              }
            </div>
          </div>
        )}





{activeTab === 'export' && (
  <div className="export-section">
    <h3 className="mb-4">📤 Paramètres d’export</h3>
    <p className="text-muted mb-5">
      Configurez les options finales avant de générer votre vidéo. Le montage est assisté par intelligence artificielle
      selon vos choix de qualité, format et ambiance sonore.
    </p>

    <div className="row g-4 mb-4">
      <div className="col-md-4">
        <label className="form-label fw-semibold">🎞 Format de sortie</label>
        <select className="form-select" value={exportConfig.format} onChange={e => setExportConfig({ ...exportConfig, format: e.target.value })}>
          <option value="mp4">MP4 (recommandé)</option>
          <option value="mov">MOV (Apple)</option>
          <option value="avi">AVI (standard)</option>
        </select>
      </div>

      <div className="col-md-4">
        <label className="form-label fw-semibold">🔍 Qualité de rendu</label>
        <select className="form-select" value={exportConfig.quality} onChange={e => setExportConfig({ ...exportConfig, quality: e.target.value })}>
          <option value="HD">HD (720p)</option>
          <option value="FullHD">Full HD (1080p)</option>
          <option value="4K">Ultra HD (4K)</option>
        </select>
      </div>

      <div className="col-md-4">
        <label className="form-label fw-semibold">🎵 Son & Ambiance</label>
        <select className="form-select" value={exportConfig.sound} onChange={e => setExportConfig({ ...exportConfig, sound: e.target.value })}>
          <option value="voiceOnly">Voix off uniquement</option>
          <option value="voiceMusic">Voix + musique de fond</option>
          <option value="musicOnly">Musique uniquement</option>
        </select>
      </div>
    </div>

    <hr className="my-5" />

    <div className="mb-5 text-center">
      <h4 className="text-primary mb-2">🚀 Génération de la vidéo finale</h4>
      <p className="text-muted">Cliquez pour lancer le montage automatique avec l’IA. Votre vidéo sera générée en quelques instants.</p>

      {generating ? (
        <div className="text-center my-5">
          <div className="spinner-grow text-info mx-2" role="status"></div>
          <div className="spinner-grow text-primary mx-2" role="status"></div>
          <div className="spinner-grow text-success mx-2" role="status"></div>
          <p className="mt-3 text-secondary">Génération en cours... Veuillez patienter ✨</p>
        </div>
      ) : (
        !finalVideoUrl && (
          <button className="btn btn-lg btn-success px-4 py-2 d-flex align-items-center gap-2" onClick={generateFinalVideo}>
            🎬 Générer la vidéo finale avec IA
          </button>
        )
      )}
    </div>

    {finalVideoUrl && (
      <div className="mt-5 p-4 bg-white rounded-4 shadow-lg text-center border border-light-subtle">
        <div className="text-success" style={{ fontSize: '3rem' }}>✅</div>
        <h4 className="mt-3">Votre vidéo est prête !</h4>
        <p className="text-muted">Voici le résultat de votre création générée par IA. Partagez-la avec le monde 🌍</p>

        <video
          src={finalVideoUrl}
          controls
          autoPlay
          className="w-100 my-4 rounded-4 shadow"
          style={{ maxWidth: "640px", maxHeight: "360px", objectFit: "cover" }}
        />

        <div className="d-flex flex-wrap justify-content-center gap-3 mt-4">
          <a href={finalVideoUrl} className="btn btn-outline-success" target="_blank" rel="noopener noreferrer">🎬 Visionner</a>
          <a href={finalVideoUrl} download className="btn btn-outline-secondary">📥 Télécharger</a>
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(finalVideoUrl)}`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">🔗 Facebook</a>
          <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(finalVideoUrl)}&text=🎥 Découvrez ce documentaire généré par IA !`} target="_blank" rel="noopener noreferrer" className="btn btn-outline-info">🐦 Twitter</a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-danger">📸 Instagram</a>
          <a href="https://www.tiktok.com/" target="_blank" rel="noopener noreferrer" className="btn btn-dark">🎵 TikTok</a>
          <button className="btn btn-outline-dark" onClick={() => {
            navigator.clipboard.writeText(finalVideoUrl);
            alert('🔗 Lien copié dans le presse-papiers !');
          }}>
            📋 Copier le lien
          </button>
        </div>

        <div className="mt-4 text-center">
          <h6>📱 Scanner pour visionner sur mobile</h6>
          <QRCodeCanvas value={finalVideoUrl} size={128} />
        </div>

        <div className="mt-5 bg-light border rounded-4 p-4 shadow-sm">
          <h5 className="text-secondary mb-3">🎉 Clôturer ce projet</h5>
          <p className="text-muted">Laissez un message de clôture à l’équipe et à la communauté pour immortaliser ce projet.</p>
          <MessageInput message={message} setMessage={setMessage} />
          <button
            className="btn btn-outline-danger"
            onClick={handleCloseProject}
          >
            ✅ Clôturer le documentaire
          </button>
        </div>
      </div>
    )}
  </div>
)}





      </div>
    </div>
  );

}


export default JourneyAdmin;
